import { useEffect } from 'react';
import { hookstate, useHookstate } from '@hookstate/core';
import {
  renovationValidate,
  retrieveAportado,
  retrieveBillHistoryList,
  retrievePlan,
  useRenovacionesFijos,
  validateAccountNumber,
} from '~/store/Query/api-renewal';
import { currencyFormat } from '~/helpers/formatter';
import productHelpers from '~/helpers/product';
import { CURRENCY, ESPOTS, IS_PROD, LOCALE, TYPE_PLAN, TYPE_POSPAGO } from '~/store/States/global';
import moment from 'moment/moment';
import { useRenewalsConfig } from '~/store/Query/api';

const renewalState = hookstate({
  texto: {
    renewals_modal_nonClaro_description:
      'Hemos detectado que tu linea no pertenece a nuestros servicios Claro. ¿Deseas contratar un servicio claro?Continúa para conocer los diferentes Pñanes que tenemos para ti',
    renewals_modal_confirm_invalid: 'PIN inválido, se enviará uno nuevo a tu numero de teléfono',
    renewals_modal_confirm_btnMesssage: 'Validar mi número',
    renewals_modal_confirm_footerText: '¿No has recibido tu PIN? Click aquí para reenviar',
    renewals_modal_prepago_btnMesssage: 'Contratar nuevos servicios',
    renewals_modal_prepago_description:
      'Hemos detectado que tu número no aplica para renovación ¿Deseas contratar un servicio postpago claro? Continúa para conocer los diferentes planes que tenemos para ti',
    renewals_modal_nonClaro_btnMesssage: 'Contratar nuevos servicios',
    renewals_modal_agreementExpired_icon: '',
    renewals_modal_prepago_icon: '',
    renewals_modal_confirm_title: 'Confirmación de PIN',
    renewals_modal_confirm_description:
      'Ingresa el PIN que enviamos a tu número de teléfono registrado para poder continuar con el proceso de renovación.',
    renewals_modal_payment_title: 'Tienes un pago pendiente',
    renewals_modal_agreementExpired_title: 'Tu contrato aún no vence',
    renewals_modal_agreementExpired_btnMesssage: 'Contratar nuevos servicios',
    modal_token_descripcion:
      'Ingresa el PIN que enviamos a tu número de teléfono  registrado para poder continuar el proceso de renovación.',
    pantalla_principal_descripcion:
      'Ingresa el número de línea, número de contrato o  factura que deseas renovar para continuar',
    pantalla_principal_info_icono: `${ESPOTS}/renovacion_fijos_movil/info_factura.gif`,
    renewals_modal_success_btnMesssage: 'Volver a inicio',
    pantalla_principal_titulo: '¿Deseas renovar tu Línea?',
    pantalla_principal_boton: 'Continuar',
    renewals_modal_success_description: 'En breve un asesor te contactará para completar el proceso de renovación',
    pantalla_principal_placeholder: 'Número a renovar, contrato o factura', //valiar
    renewals_modal_confirm_icon: '',
    modal_token_titulo: 'Confirmación de PIN',
    modal_token_boton: 'Validar mi número',
    renewals_modal_success_icon: `${ESPOTS}/renovacion_fijos_movil/Contrato_sinvencer.png`,
    renewals_modal_nonClaro_icon: '',
    renewals_modal_payment_btnLink: 'https://gt.mipagoclaro.com/#/',
    renewals_modal_prepago_title: 'Parece que cuentas con una línea prepago',
    renewals_modal_validation_title: '¡Tienes una renovación en proceso!',
    renewals_modal_validation_orden_en_proceso:
      'Puedes comunicarte al WhatsApp 3643-4554 para el seguimiento de tu renovación.',
    renewals_modal_validation_renovacion_activa:
      'Puedes comunicarte al WhatsApp 3643-4554 para el seguimiento de tu renovación.',
    renewals_modal_validation_btn_link: '/categories/postpago/planespostpago',
    renewals_modal_validation_btn_message: 'Contratar nuevos servicios',
    renewals_modal_validation_icon: `${ESPOTS}/renovacion_fijos_movil/Contrato_sinvencer.png`,
    renewals_modal_agreementExpired_description:
      'Tu contrato {agreement} aún no aplica para renovación. Te faltan {time} para poder renovar. Si deseas contratar un nuevo servicio, te sugerimos visitar nuestra Tienda en Línea',
    renewals_modal_success_title: '¡Hemos recibido tus datos!',
    renewals_modal_nonClaro_title: 'Parece que no cuentas con servicio Claro',
    renewals_modal_agreementExpired_btnLink: '/categories/postpago/planespostpago',
    renewals_modal_prepago_btnLink: '/categories/postpago/planespostpago',
    renewals_modal_payment_icon: '',
    renewals_modal_nonClaro_btnLink: '/categories/postpago/planespostpago',
    renewals_modal_success_btnLink: '/renewals',
    modal_token_reintentar: '¿No has recibido tu PIN? Click aquí para reenviar',
    renewals_modal_payment_btnMesssage: 'Pagar mi factura',
    renewals_modal_payment_description:
      'Tu numero {data} tiene un pago pendiente de {amount}. Para renovar, debes mantener al dia tu cuenta', //validar
    modal_token_error: 'PIN inválido, se enviará uno nuevo a tu número de teléfono',
    renewals_modal_lineaFija_confirm_description:
      'Ingresa el número de cualquier de tus ultimas 3 facturas para poder continuar con el proceso de renovación', //validar
    renewals_modal_lineaFija_confirm_title: 'Ingreso de factura',
    renewals_modal_lineaFija_token_boton: 'Validar mi número', //validar
    renewals_modal_lineaFija_token_error: 'Ingresa número de factura', //validar
    renewals_modal_lineaFija_placeholder: 'Ingresa tu número telefonico',
    error_insert_510:
      'local Su número de teléfono ya fue ingresado durante el día, en breve nos estaremos comunicando para atender su solicitud.', //validar
    renewals_form_title: 'Hazlo fácil,<span class="d-block d-md-none" /> seguro y ágil',
    renewals_form_btnText: 'Llamarme ahora',
    renewals_form_subtitle:
      'Ahora puedes renovar <span class="red-color text-bold d-inline">servicio móvil y servicios fijos sin salir de casa</span>. <br/> Envíanos tus datos y pronto te contactaremos.',
    renewals_form_success:
      '<span class="black-color fw-normal d-inline">Gracias por ingresar tus datos. </span> <br/><span class="fw-normal d-inline">Muy pronto te estaremos contactando</span>',
    renewals_form_contactPlaceholder: 'Teléfono de contacto',
    renewals_form_namePlaceholder: 'Nombre',
    renewals_form_emailPlaceholder: 'Correo eletrónico [opcional]',
    renewals_form_phonePlaceholder: 'Teléfono de casa [opcional]',
    service_form_type: 'Tipo de servicio',
    service_form_title: 'Servicio a renovar',
    service_form_number: 'Número de telefono',
    modal_service_confirm: 'Confirmar',
    service_form_number_contrato: 'Contrato',
    renewals_modal_billing_image: `${ESPOTS}/renovacion_fijos_movil/billing-hn.png`,
    renewals_modal_billing_description:
      'Puedes ingresar un número de factura de las últimas tres (3) facturas emitidas, sin contar la del mes actual.',
    renwals_modal_button_continue: 'Continuar',
    renewals_modal_payment_redirect: '/renewals-plan',
    renewals_modal_paymentNew_description: 'Tu numero tiene un pago pendiente. Continua para renovar', //validar
    renewals_modal_paymentNew_title: 'Tenés un pago pendiente',
    renewals_modal_payment_error_description:
      'Tienes un saldo pendiente, te invitamos a pagar para continuar con tu renovación',
    renewals_plans_title: 'Planes sugeridos para ti',
    renewals_current_plan: 'Tu Plan Actual es',
    renewals_current_benefits: 'Cuentas con los siguientes beneficios:',
    renewals_current_internet_fijo: 'Internet',
    renewals_current_minutes_fijo: 'Línea Fija',
    renewals_current_tv: 'TV',
    renewals_current_internet_movil: 'Internet',
    renewals_current_minutes_movil: 'Llamadas',
    renewals_current_messages: 'SMS',
    renewals_current_price: 'Precio Plan',
    renewals_current_price_suffix: 'mensual',
    renewals_plans_selection_fijo: 'Selecciona alguno de los siguientes planes para mejorar tu servicio Claro Hogar',
    renewals_plans_selection_movil:
      'Selecciona alguno de los siguientes planes para mejorar tu servicio Claro Postpago',
    renewals_plans_none: '¿No encuentras el plan que buscas?',
    renewals_mobile_none: '¿No encuentras el smartphone que buscas?',
    renewals_plans_none_description:
      'Solicita que un ejecutivo de ventas se comunique contigo para <b>más información</b>',
    renewals_plan_header: 'Mejora tu velocidad',
    renewals_plan_old_fijo: 'Obtienes <b class="datos">{DATOS}Megas</b> de tu plan actual',
    renewals_plan_new_fijo:
      'Obtienes <b class="datos">{DATOS}Megas</b> más por <b class="precio">{PRECIO}</b> adicionales',
    renewals_plan_old_movil: 'Obtienes <b class="datos">{DATOS}GB</b> de tu plan actual',
    renewals_plan_new_movil:
      'Obtienes <b class="datos">{DATOS}GB</b> más por <b class="precio">{PRECIO}</b> adicionales',
    renewals_plan_old_rent: 'Tu renta se mantiene de',
    renewals_plan_new_rent: 'Tu nueva renta sería de',
    renewals_plan_price_suffix: 'Mensuales',
    renewals_plan_benefits: 'Ver todos los beneficios',
    renewals_plan_button: 'Renovar ahora',
    renewals_mobile_title: 'Smartphones con tu Plan Postpago',
    renewals_selected_plan: 'Tu plan seleccionado es:',
    renewals_selected_plan_benefits: 'Tus nuevos beneficios serán:',
    renewals_selected_plan_plazo: 'Elige plazo',
    renewals_selected_plan_social: 'Redes Ilimitadas',
    renewals_form_title_fijo: 'Completa la mejora de tu plan Claro Hogar',
    renewals_form_title_fijo_no: 'Completa la solicitud para tu plan Claro hogar',
    renewals_form_title_movil: 'Completa la mejora de tu Plan Postpago',
    renewals_form_title_movil_no: 'Completa la solicitud para tu Plan Postpago',
    renewals_form_total: 'TOTAL',
    renewals_form_cambiar: 'Cambiar selección',
    renewals_form_mobile_price_prefix: 'Prima',
  },
});

export const useRenewalState = () => {
  const config = useRenovacionesFijos();
  useEffect(() => {
    if (config.data?.ok) {
      const info = config.data.body.data;
      renewalState.merge({
        ...renewalState.value,
        ...info,
        texto: {
          ...renewalState.texto.value,
          ...info.texto,
        },
      });
    }
  }, [config.data]);
  return useHookstate(renewalState);
};

export const clearNumber = () => {
  sessionStorage.removeItem('renewals.phonePostPago');
  sessionStorage.removeItem('renewals.phoneHouse');
  sessionStorage.removeItem('renewals.phoneBill');
  sessionStorage.removeItem('renewals.isPostPago');
  sessionStorage.removeItem('renewals.lob');
  sessionStorage.removeItem('renewals.plan');
  sessionStorage.removeItem('renewals.planName');
  sessionStorage.removeItem('renewals.planPrice');
  sessionStorage.removeItem('renewals.mobile');
  sessionStorage.removeItem('renewals.mobileName');
  sessionStorage.removeItem('renewals.mobilePrice');
  sessionStorage.removeItem('renewals.clientName');
  sessionStorage.removeItem('renewals.clientLastName');
  sessionStorage.removeItem('renewals.mock');
};

export const productInfo = (item, tipo) => {
  const attrMap = productHelpers.convertAttributes(item.attributes);
  const name = (attrMap['attr-conf-nombre-renovacion'] || item.locales[LOCALE].name).replace(/<br>|<br\/>|\\n/g, '\n');
  const simplename = name.replace(/\n/g, '');
  let offer = item.pricing[CURRENCY].offer_price / 100;
  const detalle = {
    datos: attrMap['attr-detalle-ancho-banda-renovacion'],
    internet: attrMap['attr-detalle-internet-renovacion'],
    llamadas: attrMap['attr-detalle-llamadas-renovacion'],
    tvsms: attrMap['attr-detalle-tv-sms-renovacion'],
  };
  if (tipo === 'movil') {
    offer = +(attrMap['attr-conf-precio-mensual-renovacion'] || attrMap['attr-conf-precio-mensual']);
  }
  const format = currencyFormat(offer, 1);
  return {
    name,
    simplename,
    offer,
    format,
    detalle,
    attrMap,
  };
};

export const renewalOrder = (order, item) => {
  const { plazo, items } = order;

  let terminal;
  let plan;
  let pricing;
  let isTerminal = false;
  let isPlan = false;

  items.forEach((it) => {
    if (it.data.type === TYPE_POSPAGO) {
      terminal = it;
    } else if (it.data.type === TYPE_PLAN) {
      plan = it;
    }
  });

  if (item?.part_number === terminal.part_number) {
    pricing = terminal.data.pricing.renewal[plan.part_number][plazo];
    isTerminal = true;
  } else if (item?.part_number === plan.part_number) {
    pricing = plan.data.pricing[CURRENCY];
    isPlan = true;
  }
  const financing = terminal.data.pricing.renewal[plan.part_number][plazo].financing;

  return {
    plazo,
    terminal,
    plan,
    pricing,
    financing,
    isTerminal,
    isPlan,
  };
};

export const simpleName = (name, replace = '') => {
  return name.replace(/<br(\/)?>|\\n|\n/g, replace);
};

export const stepInfo = (order) => {
  const { items, renewal_info } = order;

  let terminal = {
    name: '',
    price: '',
  };
  let plan;

  items.forEach((it) => {
    if (it.data.type === TYPE_POSPAGO && !renewal_info.onlyPlan) {
      terminal = {
        name: `${it.part_number}-${simpleName(it.data.locales[LOCALE].name)}`,
        price: it.price,
      };
    } else if (it.data.type === TYPE_PLAN) {
      plan = {
        name: `${it.part_number}-${simpleName(it.data.locales[LOCALE].name)}`,
        price: it.price,
      };
    }
  });

  return {
    terminal,
    plan,
  };
};

/**
 * @typedef {Object} ValidationResult
 * @property {string} lob
 * @property {boolean} displayTokenModal
 * @property {boolean} displayModal
 * @property {number} displayAlert
 * @property {string|null} modalTokenDescription
 * @property {string|null} modalTokenTitle
 * @property {string|null} modalTokenBtnText
 * @property {string|null} modalTokenPlaceholder
 * @property {string|null} modalTokenResend
 * @property {string} modalPayment
 * @property {string} agreementExpired
 * @property {boolean|null} isPostPago
 * @property {string|null} error
 * @property {string|null} errorToken
 */

/**
 * @param {boolean} start
 * @param {string} phoneNumber
 * @param {any} orderStore
 * @param {Function} generateToken
 * @param {Function} onSuccess
 * @param {any} state
 * @returns {Promise<ValidationResult>}
 */
export async function validation1(
  start,
  phoneNumber,
  orderStore,
  generateToken,
  onSuccess,
  state,
) {
  const result = {
    lob: '',
    displayTokenModal: false,
    displayModal: false,
    displayAlert: -1,
    modalTokenDescription: null,
    modalTokenTitle: null,
    modalTokenBtnText: null,
    modalTokenPlaceholder: null,
    modalTokenResend: null,
    modalPayment: '',
    agreementExpired: '',
    isPostPago: null,
    error: null,
    errorToken: null,
  };

  const queryValidateNumber = {
    validateNumber: {
      claroNumber: phoneNumber,
      UserProfileID: '',
      Type: phoneNumber.length <= 7 ? 'C' : 'N',
    },
  };

  let validateNumber;
  let genToken;
  if (!IS_PROD) {
    switch (phoneNumber) {
      case '10101010':
        sessionStorage.setItem('renewals.mock', '1');
        sessionStorage.setItem('renewals.lob', '1');
        if (start) {
          validateNumber = (async () => ({
            success: true,
            data: {
              data: {
                validateNumberResponse: {
                  AcknowledgementIndicator: 'SUCCESS',
                  IsValidFlag: true,
                  LineOfBusiness: '1',
                },
              },
            },
          }))();
          break;
        } else {
          onSuccess?.();
          return result;
        }
      case '20202020':
        sessionStorage.setItem('renewals.mock', '1');
        sessionStorage.setItem('renewals.lob', '2');
        if (start) {
          validateNumber = (async () => ({
            success: true,
            data: {
              data: {
                validateNumberResponse: {
                  AcknowledgementIndicator: 'SUCCESS',
                  IsValidFlag: true,
                  LineOfBusiness: '2',
                },
              },
            },
          }))();
          genToken = () => {
            result.lob = '2';
            result.displayTokenModal = true;
            result.displayModal = false;
          };
          break;
        } else {
          onSuccess?.();
          return result;
        }
      default:
        sessionStorage.removeItem('renewals.mock');
        validateNumber = orderStore.validateNumber(queryValidateNumber);
        genToken = generateToken;
    }
  } else {
    validateNumber = orderStore.validateNumber(queryValidateNumber);
    genToken = generateToken;
  }

  const resultVN = await validateNumber;

  if (!resultVN.success) {
    // ERROR
    if (!start) {
      onSuccess?.();
    }
    result.error = 'Ha ocurrido un error, intente más tarde.';
    return result;
  }

  const responseVN = resultVN.data.data.validateNumberResponse;
  if (
    !(
      responseVN &&
      responseVN.AcknowledgementIndicator === 'SUCCESS' &&
      responseVN.IsValidFlag &&
      !responseVN.hasProblem
    )
  ) {
    // LINEA NO CLARO
    result.displayAlert = 2;
    result.displayModal = true;
    return result;
  }

  if (responseVN.LineOfBusiness === '') {
    // ERROR NO ESPECIFICA LINEA DE BUSINESS
    result.error = 'Ha ocurrido un error, intente más tarde.';
    return result;
  }

  result.lob = responseVN.LineOfBusiness;
  sessionStorage.setItem('renewals.lob', responseVN.LineOfBusiness);
  switch (responseVN.LineOfBusiness) {
    case '1':
    case '8':
    case '9':
    case '10':
    case '17':
    case '18':
    case '19':
    case '21':
      result.modalTokenDescription = state.renewals_modal_lineaFija_confirm_description.value;
      result.modalTokenTitle = state.renewals_modal_lineaFija_confirm_title.value;
      result.modalTokenBtnText = state.renewals_modal_lineaFija_token_boton.value;
      result.modalTokenPlaceholder = state.renewals_modal_lineaFija_placeholder.value;
      result.isPostPago = false;
      result.displayTokenModal = true;
      result.displayModal = false;
      break;
    case '2':
    case '3':
      result.modalTokenDescription = state.renewals_modal_confirm_description.value;
      result.modalTokenTitle = state.renewals_modal_confirm_title.value;
      result.modalTokenBtnText = state.modal_token_boton.value;
      result.modalTokenResend = state.modal_token_reintentar.value;
      result.isPostPago = true;
      if (start) {
        result.displayTokenModal = true;
        result.displayModal = false;
      }
      genToken(responseVN.LineOfBusiness, phoneNumber);
      break;
    case '4':
      result.displayModal = true;
      result.displayAlert = 4;
      break;
  }

  return result;
}

/**
 * obtiene la diferencia de meses entre una fecha y la fecha actual
 * @param {string} incomingDate en formato DD/MM/YYYY
 * @returns {number}
 */
export function checkDatesDifference(incomingDate) {
  let monthDifference;
  if (incomingDate) {
    const date2 = moment(incomingDate, 'DD/MM/YYYY').startOf('day');
    const date1 = moment().startOf('day');
    const difference = date2.diff(date1, 'months', true);
    monthDifference = +difference.toFixed(0);
  }
  return monthDifference;
}

/**
 * @param {boolean} start
 * @param {boolean} isPostPago
 * @param {string} phoneNumber
 * @param {string} token
 * @param {string} lineOfBusiness
 * @param {number} numberBillHistory
 * @param {number} facturasPermitidas
 * @param {Function} onStorage
 * @param {any} state
 * @returns {Promise<ValidationResult>}
 */
export async function validation2(
  start,
  isPostPago,
  phoneNumber,
  token,
  lineOfBusiness,
  numberBillHistory,
  facturasPermitidas,
  onStorage,
  state,
) {
  const result = {
    lob: '',
    displayTokenModal: false,
    displayModal: false,
    displayAlert: -1,
    modalTokenDescription: null,
    modalTokenTitle: null,
    modalTokenBtnText: null,
    modalTokenPlaceholder: null,
    modalTokenResend: null,
    modalPayment: '',
    agreementExpired: '',
    isPostPago: null,
    error: null,
    errorToken: null,
  };

  async function onValidateSaldos() {
    const response = await retrieveBillHistoryList({
      retrieveBillHistoryList: {
        LineOfBusiness: lineOfBusiness,
        AccountID: phoneNumber,
        UserProfileID: '',
        BillsQuantity: numberBillHistory,
      },
    });
    if (response.ok) {
      const conSaldo = response.body.retrieveBillHistoryListResponse.BillsDetails.filter(
        (item) => item.balanceRestante !== '0',
      );

      if (conSaldo.length > 0) {
        let contador = 0;
        let amount = 0;
        conSaldo.map((item) => {
          if (moment(item.fechaVencimiento, 'DD-MM-YYYY').diff(new Date(), 'days') < 0) {
            contador += 1;
          } else {
            contador += 0;
          }
          amount += parseInt(item.balanceRestante, 10);
        });
        if (contador >= facturasPermitidas) {
          result.modalPayment = state.renewals_modal_payment_description.value
            .replace(/{amount}/g, currencyFormat(Math.round(amount * 100)))
            .replace(/{data}/g, phoneNumber);

          result.displayAlert = 0;
          result.displayModal = true;
        } else {
          if (isPostPago) {
            sessionStorage.setItem('renewals.phonePostPago', phoneNumber);
          } else {
            sessionStorage.setItem('renewals.phoneHouse', phoneNumber);
            sessionStorage.setItem('renewals.phoneBill', token);
          }
          sessionStorage.setItem('renewals.isPostPago', String(isPostPago));
          if (start) {
            result.displayAlert = 5;
            result.displayModal = true;
          } else {
            onStorage?.();
          }
        }
      } else {
        if (isPostPago) {
          sessionStorage.setItem('renewals.phonePostPago', phoneNumber);
        } else {
          sessionStorage.setItem('renewals.phoneHouse', phoneNumber);
          sessionStorage.setItem('renewals.phoneBill', token);
        }
        sessionStorage.setItem('renewals.isPostPago', String(isPostPago));
        onStorage?.();
      }
    } else {
      console.error('error al obtener las facturas', response);
    }
  }

  async function onRetrievePlan() {
    const validation = await renovationValidate(phoneNumber);
    let limitDate = '';
    if (!validation.ok) {
      const { code, result } = validation.body ?? {};
      if (code === 206) {
        if (result.status === 'renovacion_activa') {
          limitDate = moment(result.limit_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
        } else {
          result.agreementExpired = state.nested(`renewals_modal_validation_${result.status}`).value;
          result.displayAlert = 7;
          result.displayModal = true;
          return;
        }
      } else {
        result.errorToken = 'Ha ocurrido un error, intente más tarde.';
        return;
      }
    }

    const response = await retrievePlan({
      retrievePlan: {
        LineOfBusiness: lineOfBusiness,
        AccountID: phoneNumber,
        UserProfileID: '',
        reset: true,
      },
    });

    if (response.ok && response.body.retrievePlanResponse.AcknowledgementIndicator === 'SUCCESS') {
      let months = checkDatesDifference(response.body.retrievePlanResponse.PlanDetail.PlanExpirationDate);
      if (months <= 0 && limitDate) {
        months = checkDatesDifference(limitDate);
      }
      const newRenewals_modal_agreementExpired_description = state.renewals_modal_agreementExpired_description.value
        .replace(/{agreement}/g, phoneNumber)
        .replace(/{time}/g, Math.ceil(months));

      if (months <= 0) {
        await onValidateSaldos();
      } else {
        result.agreementExpired = newRenewals_modal_agreementExpired_description;
        result.displayAlert = 1;
        result.displayModal = true;
      }
    } else if (response.ok && response.body.retrievePlanResponse.AcknowledgementIndicator === 'ERROR') {
      result.displayAlert = 6;
      result.displayModal = true;
    } else {
      result.errorToken = 'Ha ocurrido un error, intente más tarde.';
    }
  }

  async function onValidateAccountNumber() {
    const response = await validateAccountNumber({
      validateAccountNumber: {
        LineOfBusiness: lineOfBusiness,
        AccountID: phoneNumber,
        UserProfileID: '',
        Bill: token,
      },
    });

    if (!('validateAccountNumberResponse' in response.body)) {
      result.errorToken = 'No hemos podido realizar su solicitud, por favor intentalo mas tarde';
      return;
    }

    if (response.ok && response.body.validateAccountNumberResponse.IsValidFlag) {
      result.errorToken = '';
      await onValidateSaldos();
    } else {
      result.errorToken = state.renewals_modal_lineaFija_token_error.value;
    }
  }

  if (isPostPago) {
    const response = await retrieveAportado({
      number: phoneNumber,
    });
    if (!response.ok || response.body.result.data.aportado) {
      await onValidateSaldos();
    } else {
      await onRetrievePlan();
    }
  } else {
    await onValidateAccountNumber();
  }

  return result
}

export const proofState = hookstate({
  msg: '',
  loaded: false,
  completed: false,
  success: false,
  document: false,
});

export const headerState = hookstate('Proceso de renovación');

export const configState = hookstate({
  dam: {
    active: false,
    chargeTitle: null,
    amount: null,
  },
});

export const useRenewalsConfigState = () => {
  const config = useRenewalsConfig();
  useEffect(() => {
    if (config.data?.ok) {
      configState.merge(config.data.body);
    }
  }, [config.data]);
  return useHookstate(configState);
};
